import { render, staticRenderFns } from "./AssetTaggable.vue?vue&type=template&id=6ce287cf"
import script from "./AssetTaggable.vue?vue&type=script&lang=js"
export * from "./AssetTaggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports